<script setup>
import Refinement from "@/Components/Algolia/Refinement.vue"

const props = defineProps({
  items: {
    required: true,
  },
  refine: {
    required: true,
  },
})
</script>

<template>
  <ul>
    <li v-for="item in props.items" :key="item.value">
      <Refinement :refine="refine" :item="item" />
      <HierarchicalMenuList
        class="ml-2"
        v-if="item.data"
        :items="item.data"
        :refine="props.refine"
      />
    </li>
  </ul>
</template>

